import { useState } from "react";
import "./ClientTable.css";
export default function ClientTable({ clients, onEdit, onDelete }) {
   const [search, setSearch] = useState("");
   const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20; // nombre par page

   // 🔍 Filtrage
  // const filteredClients = clients.filter(client =>
  //   client.nom?.toLowerCase().includes(search.toLowerCase()) ||
  //   client.email?.toLowerCase().includes(search.toLowerCase())
  // );
  const filteredClients = clients.filter(client => {
  const q = (search || "").toLowerCase();

return (
  (client?.nom || "").toLowerCase().includes(q) ||
  (client?.email || "").toLowerCase().includes(q) ||
  (client?.telephone || "").toString().toLowerCase().includes(q)
);
});

const totalPages = Math.ceil(filteredClients.length / itemsPerPage);

const startIndex = (currentPage - 1) * itemsPerPage;
const endIndex = startIndex + itemsPerPage;

const paginatedClients = filteredClients.slice(startIndex, endIndex);
  return (
  <div className="table-container">

      {/* Champ recherche */}
      <input
        type="text"
        placeholder="Rechercher par nom ou email ou telephone..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={{ padding: "8px", width: "100%", marginBottom: "15px" }}
      />
      {filteredClients.length === 0 ? (
        <p>Aucun client trouvé</p>
      ) : ( <table className="responsive-table">
      <thead>
        <tr>
          <th>Client</th>
          <th>Téléphone</th>	
          <th>Adresse</th>  
          <th>Email</th>         
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {paginatedClients.map((c) => (
       
          <tr key={c.id}>
            <td data-label="Client">{c.nom}</td>
            <td data-label="Télèphone">
               <a href={`tel:${c.telephone}`} className="phone-link"> {c.telephone}</a>
             </td>
            <td data-label="Adresse">{c.adresse}</td>
            <td data-label="Email">{c.email}</td>
            
            <td data-label="Actions">
              <button className="btn edit" onClick={() => onEdit(c)}>✏️</button>
              <button className="btn delete" onClick={() => onDelete(c.id)}>🗑</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
   )}

   <div className="pagination">
  <button
    disabled={currentPage === 1}
    onClick={() => setCurrentPage(currentPage - 1)}
  >
    ◀
  </button>

  {Array.from({ length: totalPages }, (_, i) => (
    <button
      key={i}
      className={currentPage === i + 1 ? "active" : ""}
      onClick={() => setCurrentPage(i + 1)}
    >
      {i + 1}
    </button>
  ))}

  <button
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage(currentPage + 1)}
  >
    ▶
  </button>
</div>

  </div>
  

  );
}
